
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { getInvestorAuth, getInvestorAgency } from 'api/investor'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
PopupRadio
},
data () {
return {
localValidity: '存在有效期',
orgTypeArry: [
'保险机构', '上市公司', '信托公司', '证券公司', '期货公司', '基金管理公司',
'基金管理公司子公司', '银行', '财务公司', '证券公司子公司', '期货公司子公司', '私募基金管理人',

'非金融机构企业法人', '机关法人', '事业单位法人', '社会团体法人', '非金融类非法人机构', '其他境内金融机构',
'境外代理人', '境外金融机构', '外国战略投资者', '境外非金融机构',

'私募基金管理人', '其它'
],

loading: true,
type: 0,
data: {
managerName: '',
orgType: '',
orgCertificateType: '',
orgCertificateNo: '',
orgValidity: '',
orgQualificationProve: '',
orgQualificationNo: '',
orgBusinessScope: '',
orgRegisterAddress: '',
orgRegisterCapital: '',
orgOfficeAddress: '',
orgController: ''
},
valid: {
managerName: false,
orgType: false,
orgCertificateType: false,
orgCertificateNo: false,
orgValidity: false,
orgQualificationProve: false,
orgQualificationNo: false,
orgBusinessScope: false,
orgRegisterAddress: false,
orgRegisterCapital: false,
orgOfficeAddress: false,
orgController: false
}
}
},
watch: {
localValidity: function (val, oldVal) {
if (val === '永久有效') {
this.data.orgValidity = val
} else {
this.data.orgValidity = ''
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_product_update)
this.$_product_init()
},
methods: {
$_product_update () {
this.type = 1
},
$_product_init () {
let _this = this
setTimeout(() => {
_this.type = parseInt(this.$route.query.type)
if (_this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
_this.data = {
managerName: res.managerName,
orgType: res.orgType,
orgCertificateType: res.orgCertificateType,
orgCertificateNo: res.orgCertificateNo,
orgValidity: res.orgValidity,
orgQualificationProve: res.orgQualificationProve,
orgQualificationNo: res.orgQualificationNo,
orgBusinessScope: res.orgBusinessScope,
orgRegisterAddress: res.orgRegisterAddress,
orgRegisterCapital: res.orgRegisterCapital,
orgOfficeAddress: res.orgOfficeAddress,
orgController: res.orgController
}
} else {

_this.$bridge.callHandler('getUserInfo', {msg: '获取产品ID和AU'}, (res) => {
let data = JSON.parse(res)
getInvestorAgency({userId: data.extendC, invenstemUserId: data.extendD, globalVersion: data.globalVersion}, data.au).then((response) => {
if (response.code === 0) {
let resInfo = response.data.bean
_this.data = {
managerName: resInfo.orgName,
orgType: resInfo.orgType,
orgCertificateType: resInfo.orgDocumentsType,
orgCertificateNo: resInfo.orgDocumentsNo,
orgValidity: resInfo.orgDocumentsValidity,
orgQualificationProve: resInfo.orgQualificationProve,
orgQualificationNo: resInfo.orgQualificationNo,
orgBusinessScope: resInfo.orgBusinessScope,
orgRegisterAddress: resInfo.orgRegisterAddress,
orgRegisterCapital: resInfo.orgRegisteredCapital,
orgOfficeAddress: resInfo.orgAddress,
orgController: resInfo.orgController
}
}
})
})
}
_this.loading = false
_this.$vux.loading.hide()
}, 500)
},
$_product_auth () {
this.$_product_next()


















},
$_handle_auth () {
this.$vux.loading.show({text: '加载中'})
getInvestorAuth({userId: 0, name: this.data.managerName, idcard: this.data.orgCertificateNo}, this.$route.query.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
this.$_product_next()
} else {
this.$vux.alert.show({
title: '提示',
content: res.msg
})
}
})
},
$_product_next () {
this.$route.query.type = this.type
this.$router.push({path: '/investor/product/four', query: Object.assign(this.data, this.$route.query)})
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Product/Three.vue